// Mirror of EuropassPdfBusinessSkillsSection.jsx: bullet title, then per category
// a bold category label followed by its competences joined with " | ".

import { bulletSectionTitle, run } from "../../shared/wordHelpers";
import { EUROPASS_TEXT, FONT_VERDANA, TEXT_BLACK } from "../../shared/wordTheme";
import { EU_INDENT, euPara } from "../euLayout";

export function buildEuropassBusinessSkills( { data, props, translations } ) {
    const { businessSkills } = data;
    const { documentLanguage } = props;
    const t = translations?.pdf ?? {};

    const elements = bulletSectionTitle( t.businessSkillsTitle, { font: FONT_VERDANA, indent: EU_INDENT } );

    businessSkills
        .slice()
        .sort( ( a, b ) => a.order - b.order )
        .forEach( category => {
            const categoryLabel = category?.category?.translations?.[ documentLanguage ]
                || category?.category?.label
                || "";
            elements.push( euPara( run( categoryLabel, { pt: 8, bold: true, color: TEXT_BLACK, font: FONT_VERDANA } ), { spacing: { before: 60, after: 0 } } ) );

            const competenceRuns = [];
            ( category.competences ?? [] )
                .slice()
                .sort( ( a, b ) => a.order - b.order )
                .forEach( ( competence, subIndex ) => {
                    if ( subIndex > 0 ) {
                        competenceRuns.push( run( " | ", { pt: 8, color: EUROPASS_TEXT, font: FONT_VERDANA } ) );
                    }
                    competenceRuns.push( run( competence.translations?.[ documentLanguage ] ?? "", { pt: 8, font: FONT_VERDANA } ) );
                } );
            elements.push( euPara( competenceRuns ) );
        } );

    return elements;
}
